import {i18n} from '@yourcoach/i18n';

import type {Props as AlertProps} from '../../components/Alert/types';

import {rewardProfileStore} from '../../../../api/gamification';
import {platform} from '../../../../utils/platform';
import {TestID} from '../../../../utils/test-utils/data-test-id';

const UNSAFE_ALERT_MESSAGE_PATTERNS = [
  /<\/?[a-z][\s\S]*>/i,
  /^\d{3}\s/,
  /Gateway Time-out|Bad Gateway|Service Unavailable/i,
];

const shouldSanitizeAlertMessage = (message?: string) =>
  Boolean(
    message &&
      (message.length > 300 ||
        UNSAFE_ALERT_MESSAGE_PATTERNS.some(pattern => pattern.test(message))),
  );

const sanitizeAlertProps = (props: AlertProps) => {
  if (!shouldSanitizeAlertMessage(props.message)) {
    return props;
  }

  return {
    ...props,
    message: i18n.t('shared:message.try_again_later'),
    title: i18n.t('shared:message.something_went_wrong'),
  };
};

export const processAlertProps = (props: AlertProps) => {
  const result = sanitizeAlertProps({...props});

  const shouldAppendOkButton =
    (!result.buttons || !result.buttons?.length) &&
    !result.buttonsV2?.length &&
    result.variant !== 'notification';

  if (shouldAppendOkButton) {
    result.buttons = [
      {
        label: i18n.t('shared:ok'),
        testID: TestID.generic.button.ok,
      },
    ];
  }

  /**
   * TODO: Where to place it
   * Globally override alert message and button
   * if the subscription has expired
   */
  if (
    result.message &&
    result.message === i18n.t('shared:message.subscription_expired')
  ) {
    result.message = '';
    result.title = i18n.t('shared:message.subscription_expired');
    result.buttons = [
      {
        label: i18n.t('shared:ok'),
        onClick: () => {
          if (platform.isNative) {
            rewardProfileStore.sendSubscriptionInfo();
          } else if (typeof window !== 'undefined') {
            window.location.replace('/profile/user-payments');
          }
        },
      },
    ];
  }

  return result;
};
